module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1261443"
    }
  }, [_c('b', [_vm._v("EASY SPICY CHEESE STRAWS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1261943"
    }
  }, [_c('b', [_c('i', [_vm._v("Called ")]), _vm._v("paillettes "), _c('i', [_vm._v(" (little straws) in French, these twisted strips of pastry are perfect with cocktails or wine. Feel free to substitute your favorite hard grating cheese for the Cheddar. Parmesan and Asiago are good choices.")])]), _c('b', [_c('i', [_vm._v("Frozen puff pastry makes preparation a breeze.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1264543"
    }
  }, [_c('b', [_vm._v("Prep: 30 minutes      Bake: 20 minutes per batch")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1265143"
    }
  }, [_vm._v("1 tablespoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1265443"
    }
  }, [_vm._v("½ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1266343"
    }
  }, [_vm._v("¼ to ½ teaspoon ground red pepper (cayenne)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1268143"
    }
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1269043"
    }
  }, [_vm._v("1 package (17¼ ounces) frozen puff-pastry sheets, "), _c('br'), _vm._v(" thawed")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1270543"
    }
  }, [_vm._v("1 large egg white, lightly beaten")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1270843"
    }
  }, [_vm._v("8 ounces sharp Cheddar cheese, shredded (2 cups)")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1271343"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Grease two large cookie sheets. In small bowl, combine paprika, thyme, ground red pepper, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1272343"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Unfold 1 puff-pastry sheet. On lightly floured surface, with floured rolling pin, roll pastry into 14-inch square. Lightly brush with egg white. Sprinkle half of paprika mixture on pastry. Sprinkle half of Cheddar on half of pastry. Fold pastry over to cover cheese, forming rectangle. With rolling pin, lightly roll over pastry to seal layers together. With pizza wheel or knife, cut pastry crosswise into ½-inch-wide strips.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1276143"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Preheat oven to 375°F. Place strips ½ inch apart on prepared cookie sheets, twisting each strip twice to form spiral and pressing ends against cookie sheet to prevent strips from uncurling. Bake cheese straws until golden, 20 to 22 minutes. With spatula, carefully transfer to wire racks to cool.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1279343"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Repeat with remaining puff-pastry sheet, egg white, paprika mixture, and cheese. Store in airtight container up to 1 week. Makes about 48 cheese straws.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1280943"
    }
  }, [_vm._v("Each straw: About 78 calories, 2g protein, 5g carbohydrate, 5g total fat (2g saturated), 5mg cholesterol, 68mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c71bc0be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c33_r1.vue
// module id = 165
// module chunks = 0